export const ISSUE_FORM_TYPE_OPTIONS = [
  {
    label: 'พนักงานลา',
    value: 'ON_LEAVE',
  },
  {
    label: 'เวลาสูญเสีย',
    value: 'LOSS_TIME',
  },
  {
    label: 'เครื่องจักรเสีย',
    value: 'MACHINE_BREAK',
  },
]

export const ISSUE_TYPES_OPTIONS = [
  'A1 = เครื่องจักรเสีย หรือ รออะไหล่',
  'F1 = สาเหตุอื่นๆที่ยังจัดกลุ่มไม่ได้',
  'H-C4 ลูกค้าสั่งหยุด = เหตุผลลูกค้า',
  'H-E3 พื้นที่ยุบตัว-ไม่มั่นคง',
  'H-A1 เครื่องจักรเสีย / รออะไหล่',
  'H-E2 พื้นที่น้ำท่วม',
  'H-C4 ลูกค้าสังหยุด - เหตุผลลูกค้า',
  'H-E1 พื้นที่ฝนตกฟ้าร้อง',
  'H-D2 รถขนส่งขาดส่งเสา',
  'H-A4 รออุปกรณ์สำหรับติดตั้งเสาเข็ม',
  'H-A7 รอวางฝัง(Survey ลูกค้า)',
  'H-B2 SiteSup สั่งหยุดงาน (ปัญหาอื่น)',
  'H-E3 ติดวัสดุ สิ่งกีดขวาง',
  'H-C1 ลูกค้าแก้แบบฐานรากหรือ Spec',
]

export const PROJECT_STATUS_OPTIONS = [
  {
    key: 'completed',
    title: 'เสร็จสิ้น',
  },
  {
    key: 'in-progress',
    title: 'กำลังดำเนินการ',
  },
  {
    key: 'hold',
    title: 'หยุดพัก',
  },
  {
    key: 'cancel',
    title: 'ยกเลิกโครงการ',
  },
]

export const SURVEY_STATUS_OPTIONS = [
  {
    key: 'in-progress',
    title: 'กำลังสำรวจ',
  },
  {
    key: 'completed',
    title: 'สำรวจเสร็จสิ้น',
  },
  
  {
    key: 'hold',
    title: 'อยู่ในช่วงพักการสำรวจ',
  },
  {
    key: 'cancel',
    title: 'ยกเลิกการสำรวจพื้นที่้',
  },
]

export const DELIVERY_TIME_OPTIONS = ['กลางวัน', 'กลางคืน']

export const SHIPPING_STATUS_OPTIONS = [
  {
    key: 'completed',
    title: 'เสร็จสิ้น',
  },
  {
    key: 'in-progress',
    title: 'กำลังขนส่ง',
  },
  {
    key: 'hold',
    title: 'หยุดพักการขนส่ง',
  },
  {
    key: 'cancel',
    title: 'ยกเลิกการขนส่ง',
  },
]

export const REQUEST_FORM_TYPE_OPTIONS = [
  {
    key: 'metalRequest',
    title: 'ขอแผ่นเหล็ก',
  },
  {
    key: 'pileSizeRequest',
    title: 'ขอเปลี่ยนแปลงขนาดเสา',
  },
  {
    key: 'quantityRequest',
    title: 'เพิ่มจำนวน (ขนส่ง)',
  },
]

export const REQUEST_STATUS_OPTIONS = [
  {
    key: 'pending',
    title: 'รอดำเนินการ',
  },
  {
    key: 'in-progress',
    title: 'กำลังดำเนินการ',
  },
  {
    key: 'denied',
    title: 'ไม่อนุมัติ',
  },
  {
    key: 'approved',
    title: 'อนุมัติ',
  },
]

export enum IssueType {
  RequestSteelPlates = 'RequestSteelPlates',
  RequestChangePileSize = 'RequestChangePileSize',
  RequestChangeShipping = 'RequestChangeShipping',
}

export enum IssueTypeTranslated {
  RequestSteelPlates = 'ขอแผ่นเหล็ก',
  RequestChangePileSize = 'ขอเปลี่ยนแปลงขนาดเสา',
  RequestChangeShipping = 'เพิ่มจำนวน (ขนส่ง)',
}
